import { z } from "zod";
export const FoldingRequestSchema = z.object({
  protein_seq: z.string(),
});
export type FoldingRequest = z.infer<typeof FoldingRequestSchema>;

export const ProteinStructureSchema = z.string();

export const FoldingResponseSchema = z.object({
  protein_structure: ProteinStructureSchema,
  plddt: z.array(z.number()),
});
export type FoldingResponse = z.infer<typeof FoldingResponseSchema>;

const valid_residues = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];
export const ProteinSchema = z.string().refine((s) => {
  return s.split("").every((c) => valid_residues.includes(c));
});
